import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ReactPlayer from "react-player";
import Nodata from "./Nodata";
import { serverInfo } from "../../App";
import { useContext } from "react";

import noImage from "../../assets/images/BannerAuditionAdmin.png";

const PostAllDataModule = (props) => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data } = props;
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const videoPreview = (data) => {
    
    if(data.video){
       return (
        <ReactPlayer
          url={videoCdnUrl + data.video}
          controls={true}
          volume={1}
          width="100%"
          height="200px"
          style={{ margin: "0 auto" }}
        />
      )

    }else {
      return (
         <>
            <Link
              to={`${props.urlLink}/${data.id}`}
              className="Link"
            >
              <img
                src={
                  imageCdnUrl + data.image
                    ? imageCdnUrl + data.image
                    : noImage
                }
                className="img-fluid image-hover-link"
                alt=""
                style={{ height: "200px", width: "100%" }}
              />
            </Link>
            
          </>
      )
    }
  }

  return (
    <>
      {currentItems.length !== 0 ? (
        <>
          <div className="py-3">
            <div className="row ">
              {currentItems.map((event_data) => {
                console.log(event_data.post_type);

                return (
                  <>
                    <div className="clo-sm-12 col-md-6 col-lg-3 mb-3">
                      <div className="completedMeetupBlack card-bg">
                       
                          {videoPreview(event_data)}
                            
                        <Link
                          to={`${props.urlLink}/${event_data.id}`}
                          className="Link"
                        >
                          <div className="p-3">
                            {/* <small className="text-light">
                        Event ID: &nbsp;
                        <span className="text-warning fw-bold">
                          {event_data.id}
                        </span>
                      </small> */}
                            <div className="under-line-warning my-2"></div>
                            <div className="d-flex justify-content-between">
                              {" "}
                              <h6 className="text-white text-ellipsis Title_Link">
                                {event_data.title}
                              </h6>
                            </div>

                            <p className="text-secondary head-line p-2 mt-2">
                              <h6 className="text-warning fw-bold">
                                {moment(event_data.created_at).format("LL")}
                              </h6>
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      ) : (
        <Nodata />
      )}
    </>
  );
};

export default PostAllDataModule;
